<div class="grid grid-cols-mobile-tiles lg:grid-cols-desktop-tiles gap-3 lg:gap-4">
  <app-result-card
    *ngFor="let result of results$ | async; trackBy: trackBy"
    [item]="result">
  </app-result-card>
</div>
